import { chartIconGrey, chartIconPurple, tableIconGrey, tableIconPurple } from '../../assets/hostedassets';

export const DASHBOARD_DATA_TYPES = {
    CHARTS: 'CHARTS',
    TABLE: 'TABLE',
};

export const dataTypeSelectorOptions = [
    {
        id: DASHBOARD_DATA_TYPES.CHARTS,
        icon: chartIconGrey,
        iconSelected: chartIconPurple,
        label: 'Chart',
    },
    {
        id: DASHBOARD_DATA_TYPES.TABLE,
        icon: tableIconGrey,
        iconSelected: tableIconPurple,
        label: 'Table',
    },
];

export const PRESELECT_ALL_REFRESH_MODULES_QUERY = 'preselectAllRefreshModules';
